import WarningFilledIcon from './WarningFilledIcon'

export default WarningFilledIcon
